import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { PlayersService } from '../../../services/players/players';
import { MatIconModule } from '@angular/material/icon';
import { RdGameService } from '../../../services/games/rd-game';
import { ActivatedRoute } from '@angular/router';
import { GameInfoService } from '../../../services/games/game-info';
import { TranslatePipe } from '@ngx-translate/core';
import { Downtime } from '../../../../core/services/times/downtime';

@Component({
  selector: 'app-management',
  imports: [MatDialogTitle, MatDialogContent, MatDialogClose, MatDialogActions, MatIconModule,TranslatePipe],
  templateUrl: './management.html',
  styleUrl: './management.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Management implements OnInit{
  readonly dialogRef = inject(MatDialogRef<Management>);
  data = inject(MAT_DIALOG_DATA);
  activatedRoute = inject(ActivatedRoute);
  players = inject(PlayersService);
  rdUse = inject(RdGameService);
  gameInfo = inject(GameInfoService);
  downtime = inject(Downtime);
  isClickNextTurn: boolean = false;
  isClickDelete: boolean = false;

  constructor( private ref: ChangeDetectorRef){}

  ngOnInit(): void {
    this.dialogRef.disableClose = true;
  }

  nextTurn(){
    this.downtime.refreshTimer();
    this.gameInfo.nextTurnPlayer(this.data.uuid).subscribe({
      next: (data: any) =>{
        if(!data?.room){
          console.error(`Backend did not return the next turn for room ${this.data.uuid}`);
          return;
        }
        if(data.room.other_cards != null && !Array.isArray(data.room.other_cards)){
          console.error(`Backend returned an invalid other_cards queue for room ${this.data.uuid}`);
          return;
        }
        void this.rdUse.advanceTurn(this.data.uuid, undefined, {
          expectedPlayerId: this.rdUse.game$?.turning_player_id,
          nextPlayerId: data.room.turning_player_id,
          otherCards: data.room.other_cards ?? [],
        }).then(()=>{
          this.ref.markForCheck();
          this.dialogRef.close();
        }).catch((error: unknown) =>{
          console.error(`Failed to advance turn for room ${this.data.uuid}`, error);
        });
      },
      error: (error: unknown) =>{
        console.error(`Failed to request the next turn for room ${this.data.uuid}`, error);
      },
    });
  }

  deletePlayer(player_id: number){
    this.downtime.refreshTimer();
    this.gameInfo.lastTurn(this.data.uuid).subscribe((data:any)=>{
      this.rdUse.nextTurn();
      this.players.detelePlayerByIdFBRTDB(this.data.uuid, player_id);
      this.dialogRef.close();
      this.ref.markForCheck();      
    });
    
    
  }

  confirmNext(player_id: number){
    document.querySelector(`.confirm-next[data-blockid="${player_id}"]`)?.classList.add('active')
  }

  confirmDelete(player_id: number){
    document.querySelector(`.confirm-delete[data-blockid="${player_id}"]`)?.classList.add('active')
  }

  cancelNextTurn(){
    document.querySelectorAll('.confirm-next').forEach( (item: any)=> item.classList.remove('active'))
  }

  cancelDelete(){
    document.querySelectorAll('.confirm-delete').forEach( (item: any)=> item.classList.remove('active'))
  }

}
